<mat-form-field [color]="Color">
    <mat-label>
        <ng-container *ngIf="Icon">
            <fa-icon style="margin-right: 5px" [icon]="Icon"></fa-icon>
        </ng-container>
        <span #label><ng-content select="[app-label]"></ng-content></span>
        <ng-container *ngIf="!label.children.length">{{ Key }}</ng-container>
    </mat-label>
    <input matInput [type]="Type" [placeholder]="Key" [formControl]="Value" [required]="Required" />
    <div matSuffix>
        <ng-content select="[textfieldSuffix]"></ng-content>
        <app-hint-icon [hint]="Hint" *ngIf="Hint"> </app-hint-icon>
    </div>
    <mat-error *ngIf="ErrorMessage$ | async as error">
        {{ error }}
    </mat-error>
</mat-form-field>
